const getFilterLinks = (
  isCanadaPage: boolean,
  citySlug: string,
  neighbourhoodSlug?: string
) => {
  const locationSlug = neighbourhoodSlug
    ? `${citySlug}/${neighbourhoodSlug}`
    : citySlug

  const basePath = isCanadaPage
    ? `/rental-listings`
    : `/rental-listings/city/${locationSlug}`

  const links = {
    apartment: `${basePath}/apartments`,
    townhouse: `${basePath}/townhouses`,
    house: `${basePath}/houses`,
    room: `${basePath}/rooms`,
    studio: `${basePath}/studios`,
    bed1: `${basePath}/1-bedroom`,
    bed2: `${basePath}/2-bedroom`,
    bed3: `${basePath}/3-bedroom`,
    bed4: `${basePath}/4-bedroom`,
    furnished: `${basePath}/furnished`,
    unfurnished: `${basePath}/unfurnished`,
    petFriendly: `${basePath}/pet-friendly`,
    dogFriendly: `${basePath}/dog-friendly`,
    catFriendly: `${basePath}/cat-friendly`,
    longTerm: `${basePath}/long-term`,
    shortTerm: `${basePath}/short-term`,
    monthToMonth: `${basePath}/month-to-month`,
    fixedTerm: `${basePath}/fixed-term-lease`,
    under1000: `${basePath}/under-1000`,
    under1500: `${basePath}/under-1500`,
    under2000: `${basePath}/under-2000`,
    under2500: `${basePath}?min_price=0&max_price=2500`,
    apartmentsUnder1000: `${basePath}/apartments-under-1000`,
    firstTimeRenters: `${basePath}/first-time-renters`,
    cheap: `${basePath}/cheap`
  }

  return links
}

export default getFilterLinks
